import { useState } from 'react';
import { Link } from 'react-router';
import CastFigure from '../../motion/CastFigure';
import { FolioSection, SectionMast } from '../home/HomeEditorial';
import { settlePoseFor } from './RegistrarCountdown';

function LedgerRow({ team }) {
  const [hovered, setHovered] = useState(false);
  return (
    <li
      className="rg-ledger-row"
      data-tier={team.tier}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Link to={`/draft-grades/${team.slug}`} className="rg-ledger-row__link">
        <span className="rg-ledger-row__rank">{team.rank}</span>
        <span className="rg-ledger-row__figure" aria-hidden="true">
          <CastFigure name={team.manager} pose={hovered ? settlePoseFor(team) : 'base'} trigger="none" preload={false} alt={`${team.manager} caricature`} />
        </span>
        <span className="rg-ledger-row__name">
          <strong>{team.manager}</strong>
          <small>{team.team}</small>
        </span>
        <span className="rg-ledger-row__score">{team.score.toFixed(2)}</span>
        <span className="rg-ledger-row__grade">{team.letter}</span>
        <span className="rg-curve" aria-label={`Score ${team.score.toFixed(2)} out of 100`}>
          <i style={{ width: `${team.score}%` }} />
        </span>
      </Link>
    </li>
  );
}

export default function RegistrarLedger({ teams }) {
  return (
    <FolioSection numeral="02" className="rg-ledger border-b border-border bg-bg-deep">
      <div id="registrar-ledger" className="rg-anchor" />
      <SectionMast
        tag="Final standings"
        title="The Curve."
        dek="Ten draft boards entered the Registrar's office. The scores below are now on the record."
      />
      <ol className="rg-ledger__rows" data-testid="registrar-ledger">
        {teams.map((team) => <LedgerRow key={team.slug} team={team} />)}
      </ol>
    </FolioSection>
  );
}
